import { Component, OnInit } from '@angular/core';
import { BaseContainerService, ModalContainerService, ModalService, BaseDataService } from 'yt-ng-framework';
import { RobnaGrupa } from './robna-grupa';
import { ActivatedRoute } from '@angular/router';
import { TreeviewItem, TreeItem } from 'ngx-treeview';
import { ConvItems2Treeviewitem } from './../../core/classes/conv-items2-treeviewitem'

@Component({
  selector: 'yt-robna-grupa',
  templateUrl: './robna-grupa.component.html'
})

export class RobnaGrupaComponent implements OnInit {
  list: TreeviewItem[];
  config= {  hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: true,
    maxHeight: 500
  };


  constructor(
    protected modalContainerService: ModalContainerService<RobnaGrupa>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected baseDataService: BaseDataService,
    protected baseContainerService:BaseContainerService<RobnaGrupa>
    , protected convItems2Tree: ConvItems2Treeviewitem
  ) {
  }

  ngOnInit() {
  }

OnMainItemsLoaded(){
 // this.list=this.convItems2Tree.convert(this.mainItems);
}

  // deleteItem(ID, itemName){
  //   if (
  //     confirm(
  //       this.translate.instant("DELETE.QUESTION")
  //       +(this.translate.instant('MODEL-' + this.modelData.ModelName.toUpperCase() + '.DELETE')).toUpperCase()
  //       +" "+itemName+"?")) {    
  //     super.onDeleteItem(ID);
  //   }
  // }
}
